import { CheckDescriptors } from '../types';

export const SEARCH_SETTINGS = [
    {
        id: 'search.showFacetsInSearchResults',
        area: 'search.resultsPanel',
        label: 'Show Facets in Search Results',
        description:
            'Displays a set of facets under each product name in the results grid, so similar items can be told apart without opening product details.',
    },
    {
        id: 'search.numberOfFacets',
        area: 'search.resultsPanel',
        label: 'Number of Facets in Search Results',
        description: 'The maximum number of facets shown under the name field.',
    },
    {
        id: 'search.showDesiredQuantity',
        area: 'search.resultsPanel',
        label: 'Enable Desired Quantity',
        description:
            'Lets a desired quantity be set for products in the search results, which is then used when calculating availability and pricing.',
    },
    {
        id: 'search.enableExpandedSearch',
        area: 'search.resultsPanel',
        label: 'Enable Expanded Search',
        description:
            'Allows an expanded search through supported integrations when the initial search returns few results.',
    },
    {
        id: 'search.expandedSearchThreshold',
        area: 'search.resultsPanel',
        label: 'Expanded Search Threshold',
        description:
            'The result count at or below which an expanded search is triggered with supported integrations.',
    },

    // Search settings page (/settings/search)
    {
        id: 'search.settings.keywordToTags',
        area: 'search.settings',
        label: 'Convert Keywords to Quick Tags',
    },
    {
        /*
         * Also edited from Vendor Management's "Best Price Column" section, which writes the same
         * organization feature setting (excludeFromBestPrice). One setting, one id - that surface
         * reuses this one rather than minting its own.
         */
        id: 'search.settings.excludeFromBestPrice',
        area: 'search.settings',
        label: 'Exclude from Best Price',
        description: 'Vendors excluded when calculating the best price shown on a product.',
    },
] as const;

export type _SearchSettingsAreValid = CheckDescriptors<typeof SEARCH_SETTINGS>;
